const STATUS_OPTIONS = [
  { label: 'Active', value: 'active' },
  { label: 'Deactivated', value: 'deactivated' },
];

export function makeAdminUsersFilters() {
  return [
    {
      id: 'status',
      label: 'Status',
      kind: 'select-multi',
      initialValue: ['active', 'deactivated'],
      options: STATUS_OPTIONS,
      toApiParam: { name: 'status' },
    },
  ];
}
